import {apiService} from '../apiService';
import type {
    CreateExpenseRequest,
    Expense,
    ExpenseCategory,
    MarkExpenseAsPaidRequest,
    UpdateExpenseRequest
} from 'shared-types';

export const expenseApi = {
    // GET routes
    getAll: (): Promise<Expense[]> =>
        apiService.get('/expenses/getAll'),

    getAllExpenses: (): Promise<Expense[]> =>
        apiService.get('/expenses/getAllExpenses'),

    getById: (id: string): Promise<Expense> =>
        apiService.get(`/expenses/getExpenseById/${id}`),

    getByPage: (page: number, limit: number, categories?: string): Promise<Expense[]> =>
        apiService.get(`/expenses/by-page?page=${page}&limit=${limit}&categories=${categories}`),

    getByFilter: (filters: any): Promise<Expense[]> => {
        const params = new URLSearchParams(filters);
        return apiService.get(`/expenses/filter?${params.toString()}`);
    },

    getPettyCash: (): Promise<Expense[]> =>
        apiService.get('/expenses/petty-cash'),

    // Category routes
    getAllCategories: (): Promise<ExpenseCategory[]> =>
        apiService.get('/expenses/categories'),

    getCategories: (): Promise<ExpenseCategory[]> =>
        apiService.get('/expenses/categories'),

    // POST routes
    create: (expense: CreateExpenseRequest): Promise<Expense> =>
        apiService.post('/expenses/createExpense', expense),

    createCategory: (category: { name: string }): Promise<ExpenseCategory> =>
        apiService.post('/expenses/createCategories', category),

    // PUT routes
    update: (id: string, expense: UpdateExpenseRequest): Promise<Expense> =>
        apiService.put(`/expenses/${id}`, expense),

    markAsPaid: (id: string, data: MarkExpenseAsPaidRequest): Promise<Expense> =>
        apiService.put(`/expenses/markExpenseAsPaid/${id}`, data),

    // DELETE routes
    delete: (id: string): Promise<void> =>
        apiService.delete(`/expenses/${id}`),

    deleteCategory: (id: string): Promise<void> =>
        apiService.delete(`/expenses/categories/${id}`),
};